import { render } from "./TaskFormPopup.vue?vue&type=template&id=33615e15&scoped=true&ts=true"
import script from "./TaskFormPopup.vue?vue&type=script&lang=ts"
export * from "./TaskFormPopup.vue?vue&type=script&lang=ts"

import "./TaskFormPopup.vue?vue&type=style&index=0&id=33615e15&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33615e15"]])

export default __exports__